import { GET_REGISTRATION_PAYMENT_LIST_SUCCESS, UPDATE_FINANCE_OPERATION_DATA, UPDATE_GENERATED_PAYMENT_REF } from "../action-types/finance";
import FinancialService from "../services/finance";

// *******************************
//  GET REGISTRATION PAYMENT LIST
// *******************************

export const getRegistrationPaymentList = (registrationRef) => {
    return dispatch => {
        //dispatch(setAppLoading(true));

        FinancialService.getRegistrationPaymentList(registrationRef)
        .then((response) => {
            //dispatch(setAppLoading(false));
            dispatch(getRegistrationPaymentListSuccess(response));
        })
        .catch(error => {
            //dispatch(setAppLoading(false));
            //dispatch(appError("general.popup-messages.admin.get-group-list-error"));
        });
    };
}

export const getRegistrationPaymentListSuccess = (payments) => {
    return  {
        type: GET_REGISTRATION_PAYMENT_LIST_SUCCESS,
        payments: payments
    };
}

// *******************************
//  UPDATE GENERATED PAYMENT REF
// *******************************

export const updateGeneratedPaymentRef = (paymentRef) => {
    return  {
        type: UPDATE_GENERATED_PAYMENT_REF,
        paymentRef: paymentRef
    };
}

// *******************************
//  UPDATE FINANCE OPERATION DATA
// *******************************

export const updateFinanceOperationData = (data) => {
    return  {
        type: UPDATE_FINANCE_OPERATION_DATA,
        operation: data
    };
}